import { Alert } from 'antd';
import { infoIconV2 } from './assets';
import type { InfoAlertProps } from './types';

/**
 * Shows an informational alert banner carrying a single message. Renders an Ant Design Alert of type info with the shared info icon image.
 *
 * @param props - Object holding the message text to display.
 * @returns The rendered info alert element.
 */
const InfoAlert = (props: InfoAlertProps) => (
  <Alert
    message={props.message}
    aria-label={props.message}
    type="info"
    showIcon
    icon={<img src={infoIconV2} alt="Info Icon" />}
  />
);

export default InfoAlert;
